import * as React from 'react';

/**
 *
 * useTriggerAnimationInit can be called in child component of AnimationContextWrapper wrapped parent.
 * Used if the component is rendered after the parent page render such as BaseContentfulComponent.
 * Returns the mutable element reference for the element that should be animated.
 * The hook contains the useEffect that triggers adding the element to the list
 *
 * Example of usage:
 *
 * const Child = () => {
 *  const { elementRef } = useTriggerAnimationInit(AnimationContext)
 *
 *  return <div ref={elementRef} class="animation-fade-up"></div>
 *  //animation-fade-up is out animation classname with selected animation
 * }
 *
 */
function useTriggerAnimationInit(context) {
    //the mutable reference we use for getting the selected element
    var elementRef = React.useRef(null);
    //the context returns the function that triggers adding the animation to selected element
    var initAnimationForElement = React.useContext(context).initAnimationForElement;
    React.useEffect(function () {
        //trigger adding the animation to the selected element
        initAnimationForElement({ ref: elementRef.current });
    }, [initAnimationForElement, elementRef]);
    //returns the mutable reference used to select the element from the component
    return {
        elementRef: elementRef,
    };
}

export { useTriggerAnimationInit as default };
//# sourceMappingURL=useTriggerAnimationInit.esm.js.map
